const gatblac = {
  FORMS: [
    {
      type: 'gatblac-form-contact',
      name: 'GatblacContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    },
    {
      type: 'gatblac-chatbot-request',
      name: 'GatblacNewChatbotRequest',
      message: {
        open: 'Formulario solicitud Chatbot',
        send: 'Envío Formulario solicitud Chatbot'
      }
    }
  ],
  CSS: {
    id: '617afe5a84d999329065f5be',
    name: 'gatblac-new',
    avatar: {
      name: 'gatblac-new',
      header: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-new/avatar_header.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-new/avatar_gatblacv2.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-new/avatar_activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-new/avatar_reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#F4D80C',
        borderColor: '#F4D80C'
      }
    }
  }
}

export default gatblac
